<template>
  <svg :viewBox="`0 0 ${size} ${size}`" class="score-radar" role="img" aria-label="雷达评分">
    <!-- 网格：同心多边形 -->
    <polygon
      v-for="f in [0.25, 0.5, 0.75, 1]"
      :key="f"
      class="grid"
      :points="ringPoints(f)"
    />
    <!-- 轴线 + 标签 -->
    <g v-for="(d, i) in data" :key="d.axis">
      <line class="grid" :x1="c" :y1="c" :x2="pt(i, 1).x" :y2="pt(i, 1).y" />
      <text :x="pt(i, 1.18).x" :y="pt(i, 1.18).y" class="label" text-anchor="middle" dominant-baseline="middle">{{ d.axis }}</text>
      <text :x="pt(i, 0.72).x" :y="pt(i, 0.72).y" class="score" text-anchor="middle" dominant-baseline="middle">{{ d.score }}</text>
    </g>
    <!-- 数据面 -->
    <polygon class="value" :points="data.map((d, i) => pt(i, d.score / 100).x + ',' + pt(i, d.score / 100).y).join(' ')" />
  </svg>
</template>

<script>
// 纯 SVG 雷达图（不引 echarts）。data = [{axis, score: 0-100}]
export default {
  name: 'ScoreRadar',
  props: {
    data: { type: Array, default: () => [] },
    size: { type: Number, default: 260 },
  },
  computed: {
    c() { return this.size / 2; },
  },
  methods: {
    pt(i, factor) {
      const a = -Math.PI / 2 + (2 * Math.PI * i) / Math.max(this.data.length, 3);
      const r = (this.c - 36) * factor;
      return { x: this.c + r * Math.cos(a), y: this.c + r * Math.sin(a) };
    },
    ringPoints(f) {
      return this.data.map((_, i) => { const p = this.pt(i, f); return `${p.x},${p.y}`; }).join(' ');
    },
  },
};
</script>

<style scoped>
.score-radar { width: 100%; max-width: 300px; margin: auto; display: block; }
.grid { fill: none; stroke: var(--border-1); stroke-width: 1; }
.label { fill: var(--text-2); font-size: 11px; }
.score { fill: var(--accent); font-size: 13px; font-weight: 600; }
.value { fill: var(--primary-a25); stroke: var(--primary-2); stroke-width: 2; stroke-linejoin: round; }
</style>
